import $http from "@/helpers/api";

// initial state
const state = {
    all: [],
    request: []
};

// getters
const getters = {
    getAll: state => state.all,
    getRequest: state => state.request
};

// actions
const actions = {
    getAll({
        commit,
        rootGetters
    }) {
        return new Promise((resolve, reject) => {
            $http.get("/requests", {
                params: {
                    includes: [
                        "items.part", "asf", "repair"
                    ],
                    filter_groups: [{
                        filters: [{
                            key: "asf",
                            value: rootGetters["auth/getCurrentAsf"],
                            operator: "eq"
                        }]
                    }]
                }
            }).then(resp => {
                commit("setAll", resp.data.requests);
            });
            resolve();
        });
    },
    get({
        commit
    }, request_id) {
        return new Promise((resolve, reject) => {
            $http.get("/requests/" + request_id + "?includes[]=items.part&includes[]=asf").then(resp => {
                commit("setRequest", resp.data.request);
                resolve(resp);
            }).catch(error => {
                reject(error);
            });
        });
    },
    edit({
        commit
    }, data) {
        return new Promise((resolve, reject) => {
            $http.put("/requests/" + data.id, {
                request: data
            }).then(resp => {
                resolve(resp);
            }).catch(error => {
                reject(error);
            });
        });
    },
    create(context, data) {
        return new Promise((resolve, reject) => {
            $http.post("/requests", {
                request: data
            }).then(resp => {
                resolve(resp);
            }).catch(error => {
                reject(error);
            });
        });
    },
    delete(context, data) {
        return new Promise((resolve, reject) => {
            $http.delete("/requests/" + data).then(resp => {
                resolve(resp);
            }).catch(error => {
                reject(error);
            });
        });
    }
};

// mutations
const mutations = {
    setAll(state, all) {
        state.all = all;
    },
    setRequest(state, request) {
        state.request = request;
    },
    clearAll(state) {
        state.all = [];
        state.request = [];
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
